import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import styled from "styled-components";
import { H5, P } from "../Texts";

import { Badge, PrimaryButton, LinkButton } from "../Buttons";
import AcceptOrRejectInitiativeReferral from "../../organisms/AcceptOrRejectInitiativeReferral";

const InitiativeReferralsCardStyle = styled.div`
  border-radius: 3px;
  // width: ${(props) => props.width || "fit-content"};
  width: ${(props) => props.width || "333.67px"};
  // height: ${(props) => props.height || "360px"};
`;

export const InitiativeReferralsCard = ({ referral, width, height }) => {
  const { id: orgId, initiativeId } = useParams();

  const [showCaseModal, setShowCaseModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);

  const [badgeStatusColor, setBadgeStatusColor] = useState({});

  const toggleModal = () => setShowCaseModal(!showCaseModal);
  const toggleRejectModal = () => setShowRejectModal(!showRejectModal);

  const { user, from, serviceName, eligibilityStatus, status } = referral;

  const isOrganizer = orgId === referral?.orgId;

  React.useEffect(() => {
    switch (true) {
      case status === "rejected":
        setBadgeStatusColor({
          bgColor: "#FFF0F2",
          textColor: "##AD283D",
        });
        break;

      case status === "approved":
        setBadgeStatusColor({
          bgColor: "#31A57433",
          textColor: "#31A574",
        });
        break;

      default:
        setBadgeStatusColor({
          bgColor: "#DCD6FE",
          textColor: "#2220A9",
        });
        break;
    }

    return () => {
      setBadgeStatusColor({});
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <InitiativeReferralsCardStyle
      width={width}
      height={height}
      className="bg-white p-5 shadow hover:shadow-md duration-300"
    >
      {referral?.status === "pending" && (
        <Link
          to={`/dashboard/organization/${orgId}/initiatives/${initiativeId}/view-referral/${referral.id}`}
        >
          <LinkButton
            color="#000000"
            className="mb-2 text-left hover:bg-transparent"
            p="4px 40px 4px 20px"
          >
            View
          </LinkButton>
        </Link>
      )}

      <div>
        <div
          className="w-16 h-16 flex mx-auto items-center justify-center rounded-lg mb-3"
          style={{ background: "#EAE7FE" }}
        >
          <H5 color="#12046D" className="capitalize profile-dropdown-child">
            {`${user?.firstName?.[0]} ${user?.lastName?.[0]}`}
          </H5>
        </div>

        <div className="">
          <H5
            color="#716E8B"
            fontSize="16px"
            smallSize="16px"
            className="mb-2 font-semibold text-center"
          >
            {`${referral?.user?.firstName} ${referral?.user?.lastName}`}
          </H5>
          <P
            color="#716E8B"
            fontSize="13px"
            smallSize="13px"
            className="my-0 text-center"
          >
            {user?.email}
          </P>
          <div className="mt-4">
            <P
              color="#000000"
              fontSize="16px"
              smallSize="16px"
              className="mt-0 mb-2"
            >
              Eligible:{" "}
              <span
                style={{
                  color: eligibilityStatus ? "#47C362" : "#FFBE00",
                }}
              >
                {eligibilityStatus ? "Yes" : "No"}
              </span>
            </P>
            <P
              color="#000000"
              fontSize="16px"
              smallSize="16px"
              className="my-0 truncate"
            >
              Service: {serviceName}
            </P>
          </div>

          {isOrganizer && status === "pending" ? (
            <div className="mt-10 flex justify-center mx-4">
              <PrimaryButton
                className="mr-5 w-1/2"
                style={{ backgroundColor: "#31A574", borderRadius: "4px" }}
                onClick={toggleModal}
              >
                Approve
              </PrimaryButton>

              <PrimaryButton.Light
                className="w-1/2"
                style={{
                  backgroundColor: "#FFDEDE",
                  color: "#DF0303",
                  borderRadius: "4px",
                }}
                onClick={toggleRejectModal}
              >
                Reject
              </PrimaryButton.Light>
            </div>
          ) : (
            <div className="flex justify-between items-center mt-4">
              <Badge
                className="capitalize"
                fontFamily="light"
                fontSize="12px"
                p="2px 12px"
                bg={badgeStatusColor.bgColor}
                color={badgeStatusColor.textColor}
              >
                {status}
              </Badge>

              <Link
                to={`/dashboard/organization/${orgId}/initiatives/${initiativeId}/view-referral/${referral.id}`}
              >
                <LinkButton
                  color="#000000"
                  className="text-left hover:bg-transparent"
                  p="4px 40px 4px 20px"
                >
                  View
                </LinkButton>
              </Link>
            </div>
          )}
        </div>
      </div>

      {showCaseModal && (
        <AcceptOrRejectInitiativeReferral
          header="Accept Case"
          text="Begin processing this case"
          closeModal={toggleModal}
          referral={referral}
          type="approved"
        />
      )}
      {showRejectModal && (
        <AcceptOrRejectInitiativeReferral
          header="Reject Case"
          text="You are rejecting this case and this cannot be undone!"
          closeModal={toggleRejectModal}
          referral={referral}
          type="rejected"
        />
      )}
    </InitiativeReferralsCardStyle>
  );
};
